<template>
    <div>
      <div class="level mgt-20px">
        <div class="level-left">
          <div class="columns">
            <form @submit.prevent="recherche()" class="column">
              <b-input :placeholder="$t('listeEcheanceARapprocher.actions.search')"
                       type="search"
                       icon="magnify"
                       v-model="criteresRecherche.auto">
              </b-input>
            </form>
            <div class="column is-narrow">
              <button class="button" @click='changeValueShowFiltreAndLockMenu()'>
                <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
                <span class="is-size-7">{{$t('general.button.filtre')}}
                  <label class="has-text-weight-bold"
                        :class="nombreCritere > 0 ? '' : 'is-invisible'">
                    ({{ nombreCritere }})
                  </label>
                </span>
              </button>
              <span @click="reinitialiserFiltre()"
                class="info-circle-right is-pulled-right is-cursor-pointer">
                <b-icon icon="close-circle" type="is-danger"></b-icon>
              </span>
            </div>
            <div class='column is-narrow'>
              <date-picker :dates='criteresRecherche.datesEcheance'
                           :triggerSearchEveryTime="false"
                           :updateEndDateAtChangeStartDate="false"
                           @recherche="recherche"/>
            </div>
          </div>
        </div>
        <div class="level-right columns">
          <div class="column is-narrow">
            <exportExcelButton
              :perm="constantes.permsEcheancierContrat.exporter"
              :query="exportExcelQuery"/>
          </div>
          <parametrage-table
            :reference-table="referenceTable"
            @endLoadParamtre="startArrayRendering = true">
          </parametrage-table>
        </div>
      </div>
      <v-server-table
        url=""
        :columns="columns"
        :options="options"
        :ref="referenceTable"
        @loaded="finLoading"
        @loading="debutLoading"
        v-if="startArrayRendering && mountedLoadingEnd"
        class="overflow-x-auto">
        <template slot='afterTable'>
          <table-items-in-view
            @input="$refs[referenceTable].setLimit($event)"
            :perPage="constantes.resultPerPage"/>
        </template>
        <div slot="codeAvenantBail" slot-scope="props">
          <router-link-blank :to="{ name: 'c.baux.contrat',
                    params: {id: props.row.contratId}}"
                             :message="props.row.codeAvenantBail">
          </router-link-blank>
        </div>
        <div slot="codeFace" slot-scope="props">
          <router-link-blank :to="{ name: getRouteProduitName(props.row.typeProduit),
                    params: {id: props.row.produitId}}"
                             :message="props.row.codeFace">
          </router-link-blank>
        </div>
        <div slot="periodeEcheance" slot-scope="props">
          {{ props.row.dateDebutEcheance | formatDate }}
          {{ props.row.dateFinEcheance | formatDate }}
        </div>
        <div slot="dateEcheance" slot-scope="props">
          <b-icon icon="alert" size="is-small" type="is-warning"
                  v-if="!checkDateEcheanceInPeriode(props.row)"></b-icon>
          {{ props.row.dateEcheance | formatDate }}
        </div>
        <div slot="dateFinContrat" slot-scope="props">
          {{ props.row.dateFinContrat | formatDate }}
        </div>
        <div slot="contratEtat" slot-scope="props">
          {{ getContratEtat(props.row.contratEtat) }}
        </div>
        <div slot="affectation" slot-scope="props">
          <router-link-blank v-if="props.row.affectations && props.row.affectations.length === 1"
          :to="{ name: (getInformationDirection(props.row.affectations[0])).routeName,
                params: { id: (getInformationDirection(props.row.affectations[0])).id }}"
                  :message="(getLibelleOfAffectation(props.row.affectations[0]))">
          </router-link-blank>
          <p v-else-if="props.row.affectations
            && props.row.affectations.length > 1" class="lien is-cursor-pointer"
             @click="saveInformationAndOpenPopUp(props.row)">
            {{ $t('listeFace.tab.multiple') }}
          </p>
        </div>
        <div slot="adresse" slot-scope="props">
          {{ getAdresse(props.row.adresseProduit) }}
        </div>
        <div slot="materielType" slot-scope="props">
          {{ props.row.materielType }}
        </div>
        <div slot="formatType" slot-scope="props">
          {{ props.row.formatType }}
        </div>
        <div slot="commentaireCommande" slot-scope="props" class="ellipsis">
          {{ props.row.commentaireCommande }}
        </div>
        <div slot="blocageReglement" slot-scope="props">
          {{ props.row.blocageReglement ?
          $t('general.oui') : $t('general.non') }}
        </div>
        <div slot="montantEcheanceHt" slot-scope="props" class="has-text-right">
          {{ props.row.montantEcheanceHt | formatDevise }}
        </div>
        <div slot="montantEcheanceTtc" slot-scope="props" class="has-text-right">
          {{ props.row.montantEcheanceTtc | formatDevise }}
        </div>
        <div slot="modeReglement" slot-scope="props">
          {{ getModeReglement(props.row.modeReglementId) }}
        </div>
        <template slot="indexation" slot-scope="{ row }">
          <a
            v-if="row.valeurIndexationActuel"
            @click="showIndexationEcheancier(row)">
            <b-tooltip
              :label="$t('detailContrat.indexation.affichageDonneeIndexation')"
              position="is-left">
                <b-icon type="is-primary" icon="cash-plus" size="small"/>
            </b-tooltip>
          </a>
        </template>
      </v-server-table>
      <transition name="custom-classes-transition"
                  enter-active-class="animate__animated animate__slideInRight"
                  leave-active-class="animate__animated animate__slideOutRight" :duration="10">
        <div class="componentBrief" v-show="showFiltre === true">
          <filtre-liste-echeances-a-rapprocher ref="filtreListeEcheancesARapprocher"
                                          @toggleFiltre="changeValueShowFiltreAndLockMenu()"
                                          @recherche="makeRechercheFilter"/>
        </div>
      </transition>
      <b-modal v-model="popUpAffectationsFace"
               has-modal-card>
        <pop-up-info-affectations-face :affectations="produitInformation.affectations"
                                       v-if="produitInformation"
                                       :isFromLigneFace="false"
                                       :isLogistique="false"
                                       :traduction="{
        title: $t('listeEcheanceARapprocher.infoAffectation.title',
        { code: produitInformation.codeFace }),
        noAffectation: $t('listeEcheanceARapprocher.infoAffectation.noAffectation')}">
        </pop-up-info-affectations-face>
      </b-modal>
      <b-modal
            v-model="popUpIndexationEch"
            class="modal"
            has-modal-card
            @close="popUpIndexationEch = false">
                <pop-up-indexation-echeancier
                  :echeancier="lineSelected"
                  @close="popUpIndexationEch = false"
                />
      </b-modal>
    </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import moment from 'moment';
import TableItemsInView from '@/components/general/TableItemsInView';
import datePicker from '@/components/general/datePicker';
import filtreListeEcheancesARapprocher from '@/components/baux/echeanceARapprocher/filtreListeEcheanceARapprocher';
import popUpInfoAffectationsFace from '@/components/general/p_infoAffectationsFace';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { NO_PER_PAGE_VALUE, SORT_ICON, TEXTS } from '@/configuration/clientTableConf';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { LISTE_ETAT_CONTRAT, EXPORT_EXCEL_TYPE_DONNEES_A_RAPPROCHER } from '@/configuration/baux/contrat/contratConf';
import { AFFECTATION_RESEAU, CATEGORIE_REGROUPEMENT, CATEGORIE_UNITAIRE } from '@/configuration/catalogue/produitConf';
import formatDate from '@/services/general/formatIsoDate';
import messageErreur from '@/services/general/messageErreur';
import {
  RESULTS_PER_PAGE_ECHEANCES,
} from '@/configuration/baux/echeancesAPayer/echeancesAPayerConf';
import subscribeMutation from '@/services/store/subscribeMutation';
import { ECHEANCIER_CONTRAT } from '@/configuration/baux/permissionsBauxConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import { TYPE_COMMANDE, TYPE_DEVIS } from '@/configuration/devisConf';
import { COMMANDER } from '@/configuration/affectation/affectationConf';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_FACTURES_NON_PARVENUES } from '@/configuration/general/referenceTableConf';
import popUpIndexationEcheancier from '@/components/baux/contrat/componentDetail/popUpIndexationEcheancier';

const EcheanceARapprocher = createNamespacedHelpers('echeanceARapprocher');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      loadingComponent: null,
      unsubscribeValue: null,
      showFiltre: false,
      affectations: [],
      popUpAffectationsFace: false,
      produitInformation: null,
      constantes: {
        resultPerPage: RESULTS_PER_PAGE_ECHEANCES,
        permsEcheancierContrat: ECHEANCIER_CONTRAT,
      },
      startArrayRendering: false,
      mountedLoadingEnd: false,
      referenceTable: REFERENCE_TABLE_FACTURES_NON_PARVENUES,
      popUpIndexationEch: false,
      lineSelected: null,
    };
  },
  components: {
    TableItemsInView,
    datePicker,
    filtreListeEcheancesARapprocher,
    popUpInfoAffectationsFace,
    routerLinkBlank,
    exportExcelButton,
    parametrageTable,
    popUpIndexationEcheancier,
  },
  methods: {
    ...EcheanceARapprocher.mapActions({
      loadEcheancesARapprocher: 'loadEcheancesARapprocher',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    showIndexationEcheancier(ligne) {
      this.lineSelected = ligne;
      this.popUpIndexationEch = true;
    },
    getAdresse(adresse) {
      return adressFullStringGetter(adresse, true);
    },
    getInformationDirection(affectation) {
      if (affectation.typeReference === TYPE_COMMANDE) {
        return { routeName: 'c.bodac.commandes', id: affectation.referenceId, message: affectation.codeReference };
      }
      if (affectation.typeReference === TYPE_DEVIS) {
        return { routeName: 'c.bodac.devis', id: affectation.referenceId, message: affectation.codeReference };
      }
      if (affectation.typeReference === TYPE_COMMANDE) {
        return { routeName: 'c.bodac.commandes', id: affectation.referenceId, message: affectation.codeReference };
      }
      if (affectation.sousTypeReference === CATEGORIE_REGROUPEMENT
        && affectation.typeReference === AFFECTATION_RESEAU) {
        return { routeName: 'c.bodac.catalogue-reseau', id: affectation.referenceId, message: affectation.libelle };
      }
      return { routeName: 'c.bodac.catalogue-reseauNumerique', id: affectation.referenceId, message: affectation.libelle };
    },
    saveInformationAndOpenPopUp(faceInformation) {
      this.produitInformation = faceInformation;
      this.popUpAffectationsFace = true;
    },
    checkDateEcheanceInPeriode(row) {
      return moment(row.dateEcheance).isBetween(
        moment(row.dateDebutEcheance), moment(row.dateFinEcheance), 'day', '[]',
      );
    },
    getLibelleOfAffectation(affectation) {
      let libelle = affectation.libelle;
      if (affectation.typeReference === COMMANDER) {
        libelle += this.$i18n.t('listeProduitFace.infoAffectation.commande',
          { date: formatDate(affectation.dureeAffectation.dateFin) });
      }
      return libelle;
    },
    getContratEtat(etatContrat) {
      const etatContratFind = LISTE_ETAT_CONTRAT.find((etat) => {
        return etat.code === etatContrat;
      });
      return etatContratFind ? this.$i18n.t(etatContratFind.libelle) : '';
    },
    getRouteProduitName(typeProduit) {
      if (typeProduit === CATEGORIE_UNITAIRE) return 'c.bodac.catalogue-face';
      return 'c.bodac.catalogue-ecranNumerique';
    },
    getModeReglement(id) {
      const modeReglementFind = this.parametre(PARAMETRES_KEYS.modeReglement)
        .find((modeReglement) => {
          return modeReglement.id === id;
        });
      return modeReglementFind ? modeReglementFind.libelle : '';
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.changeValueShowFiltreAndLockMenu();
      this.recherche();
    },
    async changeValueShowFiltreAndLockMenu() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeEcheancesARapprocher.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    goFirstPageAndCheckChangement() {
      if (this.criteresRecherche.agencesIds.length === 0) return;
      const agencesIds = [];
      this.criteresRecherche.agencesIds.forEach((id) => {
        const findInAgencesSelectionnes = this.agencesSelectionnees.some((agenceSelectionne) => {
          return agenceSelectionne.agenceId === id;
        });
        if (findInAgencesSelectionnes) agencesIds.push(id);
      });
      this.criteresRecherche.agencesIds = agencesIds;
      this.$refs[this.referenceTable].setPage(1);
    },
    async reinitialiserFiltre() {
      await this.$refs.filtreListeEcheancesARapprocher.initializeFiltre();
      this.$refs.filtreListeEcheancesARapprocher.viderCritere();
      this.$refs.filtreListeEcheancesARapprocher.appliquerCritere();
      this.showFiltre = false;
    },
  },
  computed: {
    ...EcheanceARapprocher.mapGetters({
      criteresRecherche: 'criteresRecherche',
      echeancesARapprocher: 'items',
      totalCount: 'total',
      lastPayload: 'lastPayload',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    nombreCritere() {
      const banCritereKey = ['auto', 'datesEcheance', 'dateFinContrat', 'blocageReglement', 'estIndexe'];
      let nombreCritere = calculNombreCritere(this.criteresRecherche, banCritereKey);
      if (this.criteresRecherche.dateFinContrat.dateDebut) {
        nombreCritere += this.criteresRecherche.dateFinContrat.dateDebut ? 1 : 0;
      }
      if (this.criteresRecherche.dateFinContrat.dateFin) {
        nombreCritere += this.criteresRecherche.dateFinContrat.dateFin ? 1 : 0;
      }
      if (this.criteresRecherche.blocageReglement !== null) nombreCritere += 1;
      if (this.criteresRecherche.estIndexe !== null) nombreCritere += 1;
      if (nombreCritere > 9) return '9+';
      return nombreCritere;
    },
    columns() {
      return ['codeAvenantBail', 'indexation', 'codeFace', 'materielType', 'formatType', 'adresse', 'adresseProduit.ville', 'dateEcheance', 'nomBailleur', 'montantEcheanceHt', 'montantEcheanceTtc', 'periodeEcheance', 'contratEtat', 'dateFinContrat', 'blocageReglement', 'motifBlocage', 'modeReglement', 'affectation', 'commentaireCommande'];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          codeAvenantBail: this.$i18n.t('listeEcheanceARapprocher.tab.codeAvenantBail'),
          codeFace: this.$i18n.t('listeEcheanceARapprocher.tab.codeFace'),
          materielType: this.$i18n.t('listeEcheanceARapprocher.tab.materielType'),
          formatType: this.$i18n.t('listeEcheanceARapprocher.tab.formatType'),
          adresse: this.$i18n.t('listeEcheanceARapprocher.tab.adresse'),
          nomBailleur: this.$i18n.t('listeEcheanceARapprocher.tab.nomBailleur'),
          periodeEcheance: this.$i18n.t('listeEcheanceARapprocher.tab.periodeEcheance'),
          dateEcheance: this.$i18n.t('listeEcheanceARapprocher.tab.dateEcheance'),
          dateFinContrat: this.$i18n.t('listeEcheanceARapprocher.tab.dateFinBail'),
          contratEtat: this.$i18n.t('listeEcheanceARapprocher.tab.etatBail'),
          blocageReglement: this.$i18n.t('listeEcheanceARapprocher.tab.blocageReglement'),
          motifBlocage: this.$i18n.t('listeEcheanceARapprocher.tab.motifBlocage'),
          montantEcheanceHt: this.$i18n.t('listeEcheanceARapprocher.tab.montantEcheanceHT'),
          montantEcheanceTtc: this.$i18n.t('listeEcheanceARapprocher.tab.montantEcheanceTTC'),
          modeReglement: this.$i18n.t('listeEcheanceARapprocher.tab.modeReglement'),
          affectation: this.$i18n.t('listeEcheanceARapprocher.tab.affectation'),
          commentaireCommande: this.$i18n.t('listeEcheanceARapprocher.tab.commentaireCommande'),
          'adresseProduit.ville': this.$i18n.t('listeEcheanceARapprocher.tab.villePanneau'),
          indexation: this.$i18n.t('listeEcheanceARapprocher.tab.indexation'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.constantes.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = cloneDeep(this.criteresRecherche);
          data.query.societeId = this.societeActiveId;
          if (this.criteresRecherche.agencesIds.length === 0) {
            data.query.agencesIds = this.agencesSelectionnees.map(agence => agence.agenceId);
          }
          return this.loadEcheancesARapprocher(data);
        }),
        columnsClasses: {
          commentaireCommande: 'colonneCommentaire',
          dateEcheance: 'colonneWidth130px',
        },
        responseAdapter: (() => {
          return {
            data: this.echeancesARapprocher,
            count: this.totalCount,
          };
        }),
        sortable: ['codeAvenantBail', 'codeFace', 'adresseProduit.ville', 'nomBailleur', 'dateEcheance', 'blocageReglement', 'motifBlocage', 'modeReglement', 'montantEcheanceHt', 'montantEcheanceTtc', 'commentaireCommande'],
        rowClassCallback: ((row) => {
          return this.checkDateEcheanceInPeriode(row) ? '' : 'background-warning-table';
        }),
      };
    },
    exportExcelQuery() {
      return {
        typeDonnee: EXPORT_EXCEL_TYPE_DONNEES_A_RAPPROCHER,
        Filtres: this.lastPayload,
      };
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
    this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPageAndCheckChangement);
      await this.loadParametres([PARAMETRES_KEYS.modeReglement]);
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
